
const _decimalSymbol = ".";
const _digitGroupingSymbol = ",";
const _percentageSymbol = "%";
const _currencySymbol = "";
const _invalidDoubleText = "";
const _emptyText = "";
const _numberOfDigitsAfterDecimal = "";

class NumberFormatInformation {

    DecimalSymbol() {
        return _decimalSymbol;
    }

    DigitGroupingSymbol() {
        return _digitGroupingSymbol;
    }

    InvalidDoubleText() {
        return _invalidDoubleText;
    }

    PercentageSymbol() {
        return _percentageSymbol;
    }

    NumberOfDigitsAfterDecimal() {
        return _numberOfDigitsAfterDecimal;
    }

    CurrencySymbol() {
        return _currencySymbol;
    }

    EmptyText() {
        return _emptyText;
    }
}

export default NumberFormatInformation;